export const FirebaseFunctionNames = Object.freeze({
    getRubric: 'grader_get_rubric',
    saveRubric: 'grader_save_rubric',
    createPdf: 'grader_create_pdf',
    completeRubric: 'grader_complete_rubric',
    getRubrics: 'grader_get_rubrics',
    validateReference: 'grader_validate_reference',
    deleteRubric: 'grader_delete_rubric',
    createExcelReport: 'grader_create_excel_report',
    getUsers: 'grader_get_users',
    getTenants: 'grader_get_tenants',
    getTenant: 'grader_get_tenant',
    createTenant: 'grader_create_tenant',
    getTenantUsers: 'grader_get_tenant_users',
    addTenantUser: 'grader_add_tenant_user',
    getTenantUser: 'grader_get_tenant_user',
    registerTenantUserPhone: 'grader_register_tenant_user_phone',
    updateTenantUserDisabled: 'grader_update_tenant_user_disabled',
    updateTenantUserPhoneSettings: 'grader_update_tenant_user_phone_settings',
    updateTenantUserPhoneSignIn: 'grader_update_tenant_user_phone_sign_in',
    updateTenantUserEmailLinkSettings: 'grader_update_tenant_user_email_link_settings',
    updateTenantSmsMfa: 'grader_update_tenant_sms_mfa',
    updateTenantUserSmsMfa: 'grader_update_tenant_user_sms_mfa',
    updateTenantTotpMfa: 'grader_update_tenant_totp_mfa',
    updateTenantUserTotpMfa: 'grader_update_tenant_user_totp_mfa',
    saveChecklist: 'grader_save_checklist',
    getChecklist: 'grader_get_checklist',
    getCourses: 'grader_get_courses',
    getCourseSections: 'grader_get_course_sections',
    getAnnouncements: 'grader_get_announcements',
    getCanvasUserProfile: 'grader_get_canvas_user_profile',
    getAssignments: 'grader_get_assignments',
    getAssignment: 'grader_get_assignment',
    getSubmissions: 'grader_get_submissions',
    getSubmission: 'grader_get_submission',
    bookmarkAssignment: 'grader_bookmark_assignment',
    getAssignmentBookmarks: 'grader_get_assignment_bookmarks',
    syncSubmissions: 'grader_sync_submissions',
    postSubmissionComment: 'grader_post_submission_comment',
    getAccount: 'grader_get_account',
    updateAccount: 'grader_update_account',
    getAttachment: 'grader_get_attachment',
    chatGPT: 'grader_chat_gpt',
    getRecentlyViewedSubmissions: 'grader_get_recently_viewed_submissions',
    getGoogleAds: 'zenrows_fetch_ads',
    getAdditionalUserInfo: 'grader_get_additional_user_info',
    postSubmissionAssessment: 'grader_post_submission_assessment',
    canvasSubmitAssessment: 'grader_canvas_submit_assessment',
    getWorklists: 'grader_get_worklists',
    prepareAllocationsRoot: 'grader_prepare_allocations_root',
    initialiseAllocations: 'grader_initialise_allocations',
    getCanvasAssignmentAllocationTrays: 'grader_get_canvas_assignment_allocation_trays',
    getCanvasAssignmentAllocationTraySubmissions: 'grader_get_canvas_assignment_allocation_tray_submissions',
    getCanvasAssignmentSubmissionsByMarkerId: 'grader_get_canvas_assignment_submissions_by_marker_id',
    getWorklistSubmissions: 'grader_get_worklist_submissions',
    getWorklistSubmission: 'grader_get_worklist_submission',
    postWorklistSubmissionComment: 'grader_post_worklist_submission_comment',
    getWorklist: 'grader_get_worklist',
    getMarkerFeedbackTemplate: 'grader_get_marker_feedback_template',
    saveMarkerFeedbackTemplate: 'grader_save_marker_feedback_template',
    getAudioAssets: 'grader_get_audio_assets',
    getAudioAsset: 'grader_get_audio_asset',
    deleteAudioAsset: 'grader_delete_audio_asset',
    migrateAudioAssetsToStorage: 'grader_migrate_audio_assets_to_storage',
    getElevenLabsVoices: 'grader_get_elevenlabs_voices',
    previewElevenLabsVoice: 'grader_preview_elevenlabs_voice',
    saveElevenLabsVoiceAsset: 'grader_save_elevenlabs_voice_asset',
    saveFeedbackTemplate: 'grader_save_feedback_template',
    getFeedbackTemplates: 'grader_get_feedback_templates',
    getFeedbackTemplate: 'grader_get_feedback_template',
    getEnabledFeedbackTemplate: 'grader_get_enabled_feedback_template',
    enableFeedbackTemplate: 'grader_enable_feedback_template',
    getStudentPerformance: 'grader_get_student_performance',
    getMarkers: 'grader_get_markers',
    saveAgent: 'grader_save_agent',
    getAgents: 'grader_get_agents',
    getAgentForMarker: 'grader_get_agent_for_marker',
    createThread: 'grader_create_thread',
    getThread: 'grader_get_thread',
    getThreadMessages: 'grader_get_thread_messages',
    sendThreadMessage: 'grader_send_thread_message',
    deleteThread: 'grader_delete_thread',
    generateRatingFeedback: 'grader_generate_rating_feedback',
    checkPhoneCodeAttempts: 'check_phone_code_attempts',
    sendPhoneVerificationCode: 'send_phone_verification_code',
    verifyPhoneCode: 'verify_phone_code',
    sendEmailLink: 'send_email_link',
    verifyEmailLink: 'verify_email_link'
} as const);